import { clsx } from 'clsx';
import { ComponentPropsWithRef } from 'react';
import { radioLabel } from './radio-input.css.ts';

export const RadioInput = function RadioInputComponent({
  ref,
  children,
  className,
  ...rest
}: ComponentPropsWithRef<'input'>) {
  return (
    <label className={clsx(className, radioLabel)} data-testid={'radio-label'}>
      <div>{children}</div>
      <input ref={ref} type={'radio'} {...rest} />
    </label>
  );
};
